import React from "react";
import logo from "../../../../assets/Images/logo.png";
import { DesktopMainMenu,  MenuLink } from "../styles";
import { Image } from "../../../Styles/style";
import twitter from "../../../../assets/Images/twitter.png"
import telegram from "../../../../assets/Images/telegram.png"
import medium from "../../../../assets/Images/medium.png"
const DesktopMenu = (props) => {
 
  return (
    <DesktopMainMenu maxWidth="xl">
      <MenuLink href="/" p="0px">
        <img src={logo} width="150" alt="Logo" />
      </MenuLink>
      <div style={{display:"flex" , alignItems:"center"}}>
        {props.menuList.map((value, i) => <MenuLink key={i} href={value.link} target={value.target} className={value.customClass}>{value.title}</MenuLink> )}
        <MenuLink p="0 5px 0 10px" href="https://twitter.com/shialending"  target="blank">
          <Image src={twitter}/>
        </MenuLink>
        <MenuLink  p="0 5px"  href="https://t.me/shialending" target="blank">
          <Image src={telegram}/>
        </MenuLink>
        <MenuLink p="0 5px">
          <Image src={medium}/>
        </MenuLink>
      </div>
    </DesktopMainMenu>
  );
};

export default DesktopMenu;
